window.sucursales=[
    {
      "IdSucursal": 1,
      "Ciudad": "Cd. Obregón",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "Calle Veracruz 425, Centro, Urb. No. 1, 85000 Cd Obregón, Son., México",
      "Telefonos": "(644) 414-49-22, 413-10-30 y 415-29-71",
      "Ubicacion": {"lat":27.4896315,"lng":-109.93566020000003},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA              ",
      "Database": 1,
      "Codigo": "OBR",
      "EmailInventario": "",
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 8,
      "Ciudad": "Culiacán Calzada",
      "Tipo": 2,
      "Nombre": "Naresa Cheff",
      "Direccion": "Calzada Heroico Colegio Militar  #3450, Col. 21 de Marzo. Sinaloa",
      "Telefonos": "(667) 718-18-27",
      "Ubicacion": {"lat":24.776237,"lng":-107.36646},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_CALZADA      ",
      "Database": 8,
      "Codigo": "CCA",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 6,
      "Ciudad": "Culiacán Zapata",
      "Tipo": 2,
      "Nombre": "Naresa Cheff",
      "Direccion": "Blvd. E. Zapata #1660 entre M. Vallarta y Av. Insurgentes. Col. Centro. Sinaloa",
      "Telefonos": "(667) 714-38-00, 01 y 02",
      "Ubicacion": {"lat":24.793199,"lng":-107.414915},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_CLN          ",
      "Database": 6,
      "Codigo": "CZA",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 9,
      "Ciudad": "Guasave",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "Emiliano Zapata 904, Col. Centro, Guasave, Sinaloa",
      "Telefonos": "(687) 138-22-22",
      "Ubicacion": {"lat":25.564168,"lng":-108.462843},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_GUASAVE      ",
      "Database": 9,
      "Codigo": "GVE",
      "EmailInventario": "",
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 3,
      "Ciudad": "Guaymas",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "La Yarda Edificio Martinez 2A. Col. Guadalupe",
      "Telefonos": "(622) 222-86-80",
      "Ubicacion": {"lat":27.92441,"lng":-110.91614},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA              ",
      "Database": 1,
      "Codigo": "GUA",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 7,
      "Ciudad": "Hermosillo Colosio",
      "Tipo": 2,
      "Nombre": "Naresa Cheff",
      "Direccion": "Av Luis Donaldo Colosio y Mariano Matamoros #17, Col. Centro. Sonora.",
      "Telefonos": "(662) 217-18-18",
      "Ubicacion": {"lat":29.080899,"lng":-110.952032},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_COLOSIO      ",
      "Database": 7,
      "Codigo": "HCO",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 4,
      "Ciudad": "Hermosillo Veracruz",
      "Tipo": 2,
      "Nombre": "Naresa Cheff",
      "Direccion": "Av Veracruz 89, San Benito, 83190 Hermosillo, Son., México",
      "Telefonos": "(662) 210-40-01, 210-40-02",
      "Ubicacion": {"lat":29.093350428040356,"lng":-110.95918473115233},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_HILLO        ",
      "Database": 4,
      "Codigo": "HVE",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 5,
      "Ciudad": "Los Mochis",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "Blvd. Antonio Rosales #259 sur Col. Centro",
      "Telefonos": "(668) 818-47-47, 815-29-66",
      "Ubicacion": {"lat":25.792779,"lng":-108.998218},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_MOCHIS       ",
      "Database": 5,
      "Codigo": "LMO",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 2,
      "Ciudad": "Navojoa",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "Talamante 606, Juárez, 85870 Navojoa, Son., México",
      "Telefonos": "(642) 421-47-44",
      "Ubicacion": {"lat":27.074296,"lng":-109.451277},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_NAV          ",
      "Database": 2,
      "Codigo": "NAV",
      "EmailInventario": null,
      "VisibleWeb": 1
    },
    {
      "IdSucursal": 10,
      "Ciudad": "Nogales",
      "Tipo": 1,
      "Nombre": "Naresa Service",
      "Direccion": "Calle Torres, Fundó Legal, Centro, 84030 Nogales, Son.\r\n",
      "Telefonos": "(631) 312-12-02",
      "Ubicacion": {"lat":31.3246641,"lng":-110.9463314},
      "Skype": "ing_luis_bobadilla_a",
      "Whatsapp": "8112135016",
      "Siscom": "NARESA_NOGALES      ",
      "Database": 10,
      "Codigo": "NGL",
      "EmailInventario": null,
      "VisibleWeb": 1
    }
  ]